import { AttributeType } from 'data/types';
import { isRequiredSpaceAttributeCode } from './required-space-attributes';

export function applySpaceAttributeAssignment(
  assigned: AttributeType[],
  allAttributes: AttributeType[],
  attributeId: number,
  shouldAssign: boolean,
  lockRequired: boolean
): AttributeType[] {
  const attribute = allAttributes.find((item) => item.id === attributeId);
  if (!attribute) {
    return assigned;
  }
  if (
    !shouldAssign &&
    lockRequired &&
    isRequiredSpaceAttributeCode(attribute.code)
  ) {
    return assigned;
  }
  if (shouldAssign) {
    if (assigned.some((item) => item.id === attributeId)) {
      return assigned;
    }
    return [...assigned, { ...attribute, required: false }];
  }
  return assigned.filter((item) => item.id !== attributeId);
}
